<template>
<div>
    <v-card>
        <v-card-title class="align-baseline">
            <v-flex xs4>
                <h2>{{ semester.name }}</h2>
            </v-flex>
            <v-flex xs4></v-flex>
            <v-flex xs4>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-flex>
        </v-card-title>
        <v-data-table :headers="headers" :items="courses" :search="search" hide-actions>
            <template slot="items" slot-scope="props">
                <tr>
                    <td>{{ props.item.section }}</td>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.teacher.first_name + ' ' + props.item.teacher.last_name }}</td>
                    <td class="text-xs-left">{{ sort(props.item.grade) }}</td>
                    <td class="text-xs-left">{{ props.item.days }}</td>
                    <td class="text-xs-left">{{ props.item.period }}</td>
                    <td class="text-xs-left">{{ props.item.current_seats + '/' + props.item.max_seats }}</td>
                    <td v-if="!props.item.active" class="text-xs-left red--text cursor-pointer" style="text-decoration: line-through;" @click="toggleClassActive(props.item)">Inactive</td>
                    <td v-else class="text-xs-left cursor-pointer" @click="toggleClassActive(props.item)">Active</td>
                    <td class="text-xs-center">
                        <v-btn color="info" @click="$router.push({ name: 'AdminEditClass', params: { semester_slug: semester.slug, course_id: props.item.id } })">Manage class</v-btn>
                    </td>
                </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
    </v-card>

</div>
</template>

<script>
import {
    sortGrades
} from '@/helpers/functions.js'

export default {
    props: {
        courses: {
            type: Array,
            required: true
        },
        semester: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            search: '',
            headers: [{
                    text: 'Section',
                    align: 'left',
                    value: 'section',
                    width: '5%'
                },
                {
                    text: 'Name',
                    align: 'left',
                    value: 'name',
                    width: '25%'
                },
                {
                    text: 'Teacher',
                    align: 'left',
                    value: 'teacher.last_name',
                    width: '15%'
                },
                {
                    text: 'Grade(s)',
                    align: 'left',
                    value: 'grade',
                    width: '10%'
                },
                {
                    text: 'Day(s)',
                    align: 'left',
                    value: 'days',
                    width: '5%'
                },
                {
                    text: 'Period',
                    align: 'left',
                    value: 'period',
                    width: '5%'
                },
                {
                    text: 'Seats',
                    align: 'left',
                    value: 'current_seats / max_seats',
                    width: '10%'
                },
                {
                    text: 'Status',
                    align: 'left',
                    value: 'active',
                    width: '5%'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    value: 'actions',
                    width: '20%'
                }
            ]
        }
    },
    methods: {
        toggleClassActive(item) {
            this.$store.dispatch('courseToggleHidden', item.id)
        },
        sort(grades) {
            return sortGrades(grades)
        }
    }
}
</script>
